<template>
  <v-select :items="items" :label="label" :value="value" :outlined="outlined" @input="value_change" data-testid="select_testing_vectograph">
    <template slot="item" slot-scope="item">
      <div style="margin-top: 5px">
        <div v-if="item.item.value">
          <img
            :src="'https://storage.googleapis.com/opticalgym-large-assets/testing/' + item.item.value + '_thumbnail.png'"
            style="background-color: black; height:80px; width: 80px;"
          />
          <div style="padding-top: 30px;  padding-left: 10px; float: right;">{{ item.item.text }}</div>
        </div>
        <div v-else>None</div>
      </div>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "Testing",
    },
    outlined: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    whitelist: {
      type: Array,
      required: false,
      default: () => null,
    }
  },
  data() {
    return {
      allItems: [
        { text: this.$t("select_testing.worth_4_dot_texture"), value: "worth_4_dot_texture" },
        { text: this.$t("select_testing.worth_4_dot_plain"), value: "worth_4_dot_plain" },
        { text: this.$t("select_testing.lr"), value: "lr" },
      ],
    };
  },
  computed: {
    items() {
      if (!Array.isArray(this.whitelist)) {
        return this.allItems;
      }

      const allowedValues = new Set(this.whitelist);
      return this.allItems.filter((item) => allowedValues.has(item.value));
    },
  },
  methods: {
    value_change(event) {
      this.$emit("input", event);
    },
  },
};
</script>
